var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("el-tabs", {
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "生成导入顺丰发函模板",
      name: "export"
    }
  }, [_c("export-component")], 1), _c("el-tab-pane", {
    attrs: {
      label: "顺丰快递单导入",
      name: "send"
    }
  }, [_c("batch-send-component")], 1), _c("el-tab-pane", {
    attrs: {
      label: "扫码核验发出",
      name: "distribute"
    }
  }, [_c("before-send-component")], 1), _vm.isHX && (_vm.isAdmin || _vm.isCpscAdmin) ? _c("el-tab-pane", {
    attrs: {
      label: "聚合下单记录",
      name: "history"
    }
  }, [_c("history-component")], 1) : _vm._e(), _vm.isHX && (_vm.isAdmin || _vm.isCpscAdmin) ? _c("el-tab-pane", {
    attrs: {
      label: "获取顺丰面单/更新订单状态/获取路由(人工干预)",
      name: "dataList"
    }
  }, [_c("data-list")], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };